import EditType from '../../../../banking/components/income-split/editor/subscreens/EditType';

export default function IncomeSplitEditTypeScreen() {
    return <EditType />;
}
